import { Modal, ModalBody, ModalHeader, VFlow } from 'bold-ui'
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import { EquipeModel } from 'view/profissional/detail/model'

import { EquipeLabel } from './EquipeLabel'
import { EquipesVinculadasTable } from './EquipesVinculadasTable'

export const EQUIPES_VINCULADAS_MODAL_URL = '/equipes-vinculadas'

interface EquipesVinculadasModalProps {
  equipePrincipal: EquipeModel
}

export function EquipesVinculadasModal(props: EquipesVinculadasModalProps) {
  const { equipePrincipal } = props
  const { url } = useRouteMatch()
  const history = useHistory()

  const handleClose = () => {
    history.push(url.replace(EQUIPES_VINCULADAS_MODAL_URL, ''))
  }

  return (
    <Modal open onClose={handleClose}>
      <ModalHeader title='Equipes vinculadas' />
      <ModalBody>
        <VFlow>
          <EquipeLabel nome={equipePrincipal.nome} ine={equipePrincipal.ine} />
          <EquipesVinculadasTable equipePrincipalId={equipePrincipal.id} />
        </VFlow>
      </ModalBody>
    </Modal>
  )
}
